<div class="border-y-2 border-[#e6b012] shadow-md relative overflow-hidden py-1.5">
  <!-- RIDC Building background image -->
  <img src="assets/images/ridc-building.jpg" alt="" class="absolute inset-0 w-full h-full object-cover pointer-events-none" />
  <!-- Dark green overlay -->
  <div class="absolute inset-0 pointer-events-none" style="background: linear-gradient(to right, rgba(14,59,46,0.96), rgba(10,46,35,0.92), rgba(14,59,46,0.96));"></div>
  <div class="relative z-10 max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center gap-0">
    
    <!-- LEFT BLOCK: Official Partners Info -->
    <div class="shrink-0 flex items-center gap-3 py-2 pr-6 md:border-r border-white/20">
      <!-- Gold Vertical Bar with Teal Indicator Dot -->
      <div class="relative flex flex-col items-center justify-center h-9 w-1 bg-[#e6b012] rounded-full">
        <span class="w-2.5 h-2.5 rounded-full bg-teal-400 border border-[#0e3b2e] absolute -bottom-1 shadow-xs"></span>
      </div>

      <!-- Labels -->
      <div class="flex flex-col">
        <span class="text-[10px] font-black uppercase tracking-widest text-[#e6b012]">OFFICIAL PARTNERS</span>
        <span class="text-sm font-bold text-white leading-tight">Enrolled Institutions</span>
        <span class="text-[10px] font-medium text-emerald-200/80">50+ Institutions Connected</span>
      </div>
    </div>

    <!-- RIGHT BLOCK: White Marquee Box -->
    <div class="flex-1 w-full bg-white h-14 md:my-0 relative overflow-hidden flex items-center logos">
      <div class="logo_items flex items-center gap-12 px-6">
        @for (institution of enrolledInstitutions; track $index) {
          <div class="h-9 shrink-0 flex items-center justify-center">
            <img [src]="institution.imagePath" alt="institution logo" class="h-7 max-w-[110px] w-auto object-contain" />
          </div>
        }
        @for (institution of enrolledInstitutions; track $index) {
          <div class="h-9 shrink-0 flex items-center justify-center">
            <img [src]="institution.imagePath" alt="institution logo" class="h-7 max-w-[110px] w-auto object-contain" />
          </div>
        }
      </div>
    </div>

  </div>
</div>
